module.exports = __webpack_public_path__ + "static/media/assets_phone.1819f2f0.svg";